<template>
    <div>
        <input type="number" :id="getName" class="form-control" :name="getName" v-model="proxyValue"/>
    </div>
</template>

<script>

export default
{
    components: {},
    props: {
        column: {
            type: Object,
        },
        config: {
            type: Object,
        },
        row: {
            type: Object,
        },
    },
    data() {
        return {

        };
    },
    computed: {
        getName() {
            return this.config.name || 'name';
        },
        getValue() {
            return this.row[this.column.data];
        },
        proxyValue: {
            get() { return this.getValue; },
            set(newValue) {
                let value = newValue.length > 0 ? parseFloat(newValue) : null;
                this.$emit('input', value);
                this.row[this.column.data] = value;
            }
        },
    },
    mounted() {
    },
    methods: {
    },
}
</script>

<style lang="sass">
</style>


// WEBPACK FOOTER //
// NumberInputColumnComponent.vue?433796e8